import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { TranslateService } from '@ngx-translate/core'; // Import TranslateService
import { AdminUserAuthConstants } from '../../common/admin-auth-constant';

@Injectable({
  providedIn: 'root',
})
export class MenustateService {
  //#region main menu value
  adminPermission = AdminUserAuthConstants;
  
  menuItems = [
    {
      id: 1,
      name: 'Dashboard',
      permission: "Dashboard",
      icon: 'fa-solid fa-table-columns',
      openIcon: 'fa-solid fa-table-columns',
      link: '/dashboard/dashboard',
      isOpen: false,
      isSelected: true,
      subMenu: [],
    },
    {
      id: 2,
      name: 'Verification',
      icon: 'fa-solid fa-folder-closed',
      openIcon: 'fa-solid fa-folder-open',
      isOpen: false,
      isSelected: false,
      subMenu: [
        {
          permission: "Verification.Level1",
          icon: 'fa-regular fa-circle-user',
          isSelected: false,
          link: '/verification/paymeverificationlist',
          title: 'LV1 Verification'
        },
        {
          permission: "Verification.Level2",
          icon: 'fa-regular fa-circle-user',
          isSelected: false,
          link: '/verification/lv2verificationlist',
          title: 'LV2 Verification'
        },
        {
          permission: 'Verification.PDLevel1',
          icon: 'fa-regular fa-circle-user',
          isSelected: false,
          link: '/verification/pdofficerl1verification',
          title: 'PD Officer L1 Verification'
        },
        {
          permission: "Verification.PDLevel2",
          icon: 'fa-regular fa-circle-user',
          isSelected: false,
          link: '/verification/pdofficerl2verification',
          title: 'PD Officer L2 Verification'
        },
        {
          permission: "Verification.VerifiedUser",
          icon: 'bi bi-person-check fw-bolder fs-5',
          isSelected: false,
          link: '/verification/verifiedpensioners',
          title: 'Verified Pensioners'
        },
        {
          permission: "Verification.RejectedUser",
          icon: 'bi bi-person-slash fw-bolder fs-5',
          isSelected: false,
          link: '/verification/rejectedpaymeuser',
          title: 'Rejected User'
        },
        // {
        //   permission: "Verification.RejectPension",
        //   icon: 'bi bi-person-slash fw-bolder fs-5',
        //   isSelected: false,
        //   link: '/verification/rejectedpension',
        //   title: 'Rejected Pension'
        // },
        {
          permission: "Verification.PensionExpire",
          icon: 'bi bi-person-slash fw-bolder fs-5',
          isSelected: false,
          link: '/verification/expiredliveverification',
          title: 'Restricted Access'
        }
      ],
    },
    {
      id: 3,
      name: 'Pensioner Management',
      icon: 'fa-solid fa-person-cane fs-5',
      openIcon: 'fa-solid fa-person-cane fs-5',
      isOpen: false,
      isSelected: false,
      subMenu: [
        {
          permission: "Pensioner.PayMeUser",
          icon: 'fa-regular fa-user',
          isSelected: false,
          link: '/pensionermanagement/paymeuser',
          title: 'PayMe User',
        },
        {
          permission: "Pensioner.PayMePension",
          icon: 'fa-regular fa-user',
          isSelected: false,
          link: '/pensionermanagement/paymepensionlist',
          title: 'PayMe Pension',
        },
        {
          permission: "Pensioner.DeceasedUser",
          icon: 'fa-solid fa-ribbon',
          isSelected: false,
          link: '/pensionermanagement/deceasedpension',
          title: 'Deceased Pensioner',
        },
        {
          permission: "Pensioner.ImportedPension",
          icon: 'fa-regular fa-user',
          isSelected: false,
          link: '/pensionermanagement/pensionerdatalist',
          title: 'Imported Pension',
        },
        // {
        //   permission: "Pensioner.ImportedBatchFile",
        //   icon: 'fa-regular fa-file-excel',
        //   isSelected: false,
        //   link: '/pensionermanagement/batchfilelist',
        //   title: 'Imported Batch File',
        // },
      ],
    },
    {
      id: 4,
      name: 'External Agent Management',
      icon: 'fa-solid fa-user',
      openIcon: 'fa-solid fa-user',
      isOpen: false,
      isSelected: false,
      subMenu: [
        {
          permission: "FOSAgent.Level1",
          icon: 'fa-regular fa-circle-user',
          isSelected: false,
          link: 'agentmanagement/lv1verification',
          title: 'Level1 Verification'
        },
        {
          permission: "FOSAgent.Level2",
          icon: 'fa-regular fa-circle-user',
          isSelected: false,
          link: 'agentmanagement/lv2verification',
          title: 'Level2 Verification'
        },
        // {
        //   permission: "FOSAgent.Level3",
        //   icon: 'fa-regular fa-circle-user',
        //   isSelected: false,
        //   link: 'agentmanagement/lv3verification',
        //   title: 'Level3 Verification'
        // },
        {
          permission: "FOSAgent.AgentList",
          icon: 'fa-regular fa-circle-user',
          isSelected: false,
          link: 'agentmanagement/agentlist',
          title: 'Active Agents'
        },
        {
          permission: "FOSAgent.CashoutTransaction",
          icon: 'fa-solid fa-money-bill',
          title: 'Agent Transaction',
          link: 'agentmanagement/transactionlist',
          isSelected: false
        },
        {
          permission: "FOSAgent.ReconcileReport",
          icon: 'fa-solid fa-money-bill',
          title: 'Reconciliation Report',
          link: 'agentmanagement/reconcilationreport',
          isSelected: false
        }
      ],
    },
    {
      id: 13,
      name: 'Fund Out',
      permission: "FundOut.Transaction",
      icon: 'fa-solid fa-money-bill',
      openIcon: 'fa-solid fa-money-bill',
      isOpen: false,
      isSelected: true,
      link: '/fundout/funouttransactionlist',
      subMenu: [
        // {
        //   permission: "FundOut.Transaction",
        //   icon: 'fa-solid fa-money-bill',
        //   isSelected: false,
        //   link: '/fundout/funouttransactionlist',
        //   title: 'Fund Out Transaction',
        // },
        // {
        //   permission: "Admin.UserSetup",
        //   icon: 'fa fa-file',
        //   isSelected: false,
        //   link: '/fundout/funoutform',
        //   title: 'Fund Out Form',
        // }
      ]
    },
    {
      id: 5,
      name: 'Employee Management',
      icon: 'fa-solid fa-user-tie',
      openIcon: 'fa-solid fa-user-tie',
      isOpen: false,
      isSelected: false,
      subMenu: [
        {
          permission: "Employee.UserSetup",
          icon: 'fa-regular fa-pen-to-square',
          isSelected: false,
          link: '/fosmanagement/registerfos',
          title: 'New Employee Registration',
        },
        {
          permission: "Employee.UserList",
          icon: 'fa-regular fa-user',
          isSelected: false,
          link: '/fosmanagement/fosagentlist',
          title: 'Employee Agents',
        },
        {
          permission: "Employee.RoleSetup",
          icon: 'fa-regular fa-chart-bar',
          isSelected: false,
          link: '/fosmanagement/fosroles/list',
          title: 'Employee Roles',
        },
        // { permission:'9', icon: 'fa-regular fa-file-lines', isSelected: false, link: '/fosmanagement/fosroles/lists', title: 'Task Assignment' },
        // { permission:'10', icon: 'bi bi-clock-history', isSelected: false, link: '/agency', title: 'Assigned History' },
      ],
    },
    {
      id: 6,
      name: 'Request Management',
      icon: 'fa-solid fa-paper-plane',
      openIcon: 'fa-solid fa-paper-plane',
      isOpen: false,
      isSelected: false,
      subMenu: [
        // {
        //   permission: "Request.NewRequest",
        //   icon: 'fa-regular fa-file-lines',
        //   isSelected: false,
        //   link: '/requestmanagement/createrequestsearch',
        //   title: 'New Request',
        // },
        {
          permission: "Request.ChangeRequestApproval",
          icon: 'bi bi-clock',
          isSelected: false,
          link: '/requestmanagement/changerequestlist',
          title: 'Information Change Request',
        },
        // {
        //   permission: "Request.ServiceRequest.HomeEnrollment",
        //   icon: 'bi bi-clock',
        //   isSelected: false,
        //   link: '/requestmanagement/servicerequestlist',
        //   title: 'Service Request',
        // },
        // { permission:'ServiceRequest.List', icon: 'bi bi-clock', isSelected: false, link: '/requestmanagement/multiassign', title: 'Multiple Assign' },
        // {
        //   permission: 'ServiceRequest.List',
        //   icon: 'bi bi-clock',
        //   isSelected: false,
        //   link: '/requestmanagement/livemonitoring',
        //   title: 'Live Monitoring',
        // },
        // { permission:'14', icon: 'bi bi-clock-history', isSelected: false, link: '/requestmanagement/requesthistorys', title: 'Request History' },
      ],
    },
    {
      id: 7,
      name: 'Cash Management',
      icon: 'fa-solid fa-money-bill',
      openIcon: 'fa-solid fa-money-bill',
      isOpen: false,
      isSelected: false,
      subMenu: [
        {
          permission: "CashEntry",
          icon: 'fa-solid fa-money-bill',
          isSelected: false,
          link: '/cashout/cashentrylist',
          title: 'Cash Entry',
        },
         {
          permission: "CashRequest",
          icon: 'fa-solid fa-money-bill',
          isSelected: false,
          link: '/cashout/cashrequestlist',
          title: 'Cash Request',
        },
        {
          permission: "Cashout.PensionCashout",
          icon: 'fa-solid fa-money-bill',
          isSelected: false,
          title: 'Cash Out',
          isOpen: false,
          link: 'cashout/inquiry',
          // innerSubMenu: [
          //   {
          //     title: 'Pension Cashout',
          //     link: 'cashout/inquiry',
          //     isSelected: false
          //   },
          //   {
          //     title: 'OTC Transaction',
          //     link: 'cashout/transaction',
          //     isSelected: false
          //   }
          // ]
        },
        {
          permission: "CashReturn",
          icon: 'fa-solid fa-money-bill',
          isSelected: false,
          link: '/cashout/cashreturnlist',
          title: 'Cash Return',
        }
        // {
        //    permission: "Cashout.Transaction",
        //    icon: 'fa-solid fa-money-bill',
        //    isSelected: false,
        //    link: 'cashout/transaction',
        //    title: 'Cashout Transaction',
        //  }
      ],
    },
    {
      id: 14,
      name: 'Cash Out Transaction',
      icon: 'fa fa-file',
      openIcon: 'fa fa-file',
      isOpen: false,
      isSelected: false,
      subMenu: [
        {
          permission: "CashoutTransaction.PayMeReport",
          icon: 'fa-solid fa-money-bill',
          isSelected: false,
          link: 'cashouttransaction/transaction',
          title: 'PayMe Cash Out Transaction',
        },
        {
          permission: "CashoutTransaction.PDReport",
          icon: 'fa-solid fa-money-bill',
          isSelected: false,
          link: 'cashouttransaction/pdtransaction',
          title: 'Cash Out Transaction',
        }
      ]
    },
    {
      id: 13,
      name: 'Transaction Report',
      icon: 'fa fa-file',
      openIcon: 'fa fa-file',
      isOpen: false,
      isSelected: false,
      subMenu: [
        {
          permission: "TransactionReport.Upcoming",
          icon: 'fa-solid fa-money-bill',
          isSelected: false,
          link: 'transactionreport/upcomingtransactionlist',
          title: 'Upcoming Transactions',
        },
        {
          permission: "TransactionReport.Last",
          icon: 'fa-solid fa-money-bill',
          isSelected: false,
          link: 'transactionreport/transactionreportlist',
          title: 'Last Transactions',
        }
        
      ]
    },
    {
      id: 8,
      name: 'Admin Management',
      icon: 'fa-solid fa-user',
      openIcon: 'fa-solid fa-user',
      isOpen: false,
      isSelected: false,
      subMenu: [
        {
          permission: "Admin.UserSetup",
          icon: 'fa-regular fa-user',
          isSelected: false,
          link: '/admin/user/list',
          title: 'User Setup',
        },
        {
          permission: "Admin.RoleSetup",
          icon: 'bi bi-people',
          isSelected: false,
          link: '/admin/role/list',
          title: 'Role Setup',
        },
        {
          permission: "Admin.MinistrySetup",
          icon: 'bi bi-buildings',
          isSelected: false,
          link: '/admin/ministry/list',
          title: 'Ministry Setup',
        },
        {
          permission: "Admin.DepartmentSetup",
          icon: 'fa-regular fa-building',
          isSelected: false,
          link: '/admin/department/list',
          title: 'Department Setup',
        },
        {
          permission: "Admin.RegionSetup",
          icon: 'bi bi-building-gear',
          isSelected: false,
          link: '/admin/region/list',
          title: 'Region Setup',
        },
        {
          permission: "Admin.CashCollectionPointSetup",
          icon: 'bi bi bi-map',
          isSelected: false,
          link: '/admin/cashcollectionpoints/list',
          title: 'Cash Collection Points',
        },
      ],
    },
    {
    id: 14,
    name: 'PinSinPay',
    icon: 'fa-brands fa-app-store',
    openIcon: 'fa-brands fa-app-store',
    isOpen: false,
    isSelected: false,
    subMenu: [
      {
          permission: "PinSinPay.FailedLivenessReview",
          icon: 'fa-solid fa-camera-rotate',
          isSelected: false,
          link: 'pinsinpay/failedLivenesslist',
          title: 'Failed Liveness Verification Review',
        },
    ]
  },
    {
      id: 11,
      name: 'Notification',
      permission: 'Nominee',
      icon: 'fa fa-bell',
      openIcon: 'fa fa-bell',
      isOpen: false,
      isSelected: false,
      subMenu: [
        {
          permission: "Admin.UserSetup",
          icon: 'fa fa-plus',
          isSelected: false,
          link: '/notification/createnotification',
          title: 'Create Notification',
        },
        {
          permission: "Admin.UserSetup",
          icon: 'fa fa-history',
          isSelected: false,
          link: '/notification/notificationlogs',
          title: 'Notification Logs',
        },
        {
          permission: "Admin.UserSetup",
          icon: 'far fa-clock',
          isSelected: false,
          link: '/notification/scheduledlist',
          title: 'Scheduled List',
        }
      ]
  },
    {
      id: 9,
      name: 'Nominee',
      permission: 'Nominee',
      icon: 'fa-regular fa-user',
      openIcon: 'fa-regular fa-user',
      link: '/nomineeonly/nomineelist',
      isOpen: false,
      isSelected: true,
      subMenu: [
      ]
  },
  {
    id: 12,
    name: 'Settlement Import Batch File',
    permission: "Settlement.ImportedBatchFile",
    icon: 'fa-regular fa-file-excel',
    openIcon: 'ffa-regular fa-file-excel',
    isSelected: false,
    link: 'settlement/settlementlist',
    subMenu: [
    ]
  },
  {
  id: 10,
  name: 'Proxy File Upload',
  permissionCheck: (permissions: string[]) =>
    permissions.includes('ProxyFile.List') ||
    permissions.includes('ProxyFile.Upload'),
  icon: 'fa-regular fa-file-excel',
  openIcon: 'fa-regular fa-file-excel',
  isSelected: false,
  link: 'proxyfile/proxyfileupload',
  subMenu: []
}
    
  ];
  //#endregion

  checkPermission(): boolean {
    return (
      this.adminPermission?.ProxyFile?.ProxyFileList === 'ProxyFile.List' ||
      this.adminPermission?.ProxyFile?.ProxyFileUpload === 'ProxyFile.Upload'
    );
  }

  // checkPermission(): boolean {
  //   console.log('check permission', this.adminPermission?.ProxyFile?.ProxyFileList === 'ProxyFile.List' ||
  //     this.adminPermission?.ProxyFile?.ProxyFileUpload === 'ProxyFile.Upload');
  //   return (
  //     this.adminPermission?.ProxyFile?.ProxyFileList === 'ProxyFile.List' ||
  //     this.adminPermission?.ProxyFile?.ProxyFileUpload === 'ProxyFile.Upload'
  //   );
  // }

  routerSecrectKey = '----^-----';

  //#region route navigation loading
  private loadingSubject = new BehaviorSubject<boolean>(false);
  loading$ = this.loadingSubject.asObservable();

  show() {
    this.loadingSubject.next(true);
  }

  hide() {
    this.loadingSubject.next(false);
  }
  //#endregion

  private menuStateSubject = new BehaviorSubject<any>(this.loadMenuState());
  menuState$ = this.menuStateSubject.asObservable();

  constructor(private translate: TranslateService) {}

  resetMenuState() {
    this.menuStateSubject.next(this.loadMenuState());
  }
  private loadMenuState() {
    return this.getDefaultMenuState();
    // const savedMenuState = localStorage.getItem('menuState');
    // return savedMenuState ? JSON.parse(savedMenuState) : this.getDefaultMenuState();
  }

  private getDefaultMenuState() {
    return this.menuItems;
  }

  updateMenuState(menuItems: any[]): void {
    this.menuStateSubject.next(menuItems);
    // this.menuItems = menuItems;
  }

  updateSelectedMenu(currentUrl: string): void {
    // this.menuItems.forEach((menu: any) => {
    //   menu.isSelected = false;
    //   menu.subMenu.forEach((subMenu: any) => (subMenu.isSelected = false));

    //   if (currentUrl.includes('dashboard') && menu.id == 1) {
    //     menu.isSelected = true;
    //   } else {
    //     if ( menu.subMenu.some((subMenu: any) => currentUrl.includes(subMenu.link))) {
    //       menu.isSelected = true;
    //       menu.isOpen = true;

    //       menu.subMenu.forEach((subMenu: any) => {
    //         if (currentUrl.includes(subMenu.link)) {
    //           subMenu.isSelected = true;
    //         }
    //       });
    //     }
    //   }
    // });

  // this.menuItems.forEach((menu: any) => {
  //   menu.isSelected = false;
  //   menu.isOpen = false;

  //   menu.subMenu.forEach((subMenu: any) => {
  //     subMenu.isSelected = false;
  //     subMenu.isOpen = false;

  //     // reset innerSubMenu selection
  //     if (subMenu.innerSubMenu) {
  //       subMenu.innerSubMenu.forEach((inner: any) => {
  //         inner.isSelected = false;
  //       });
  //     }
  //   });

  //   // DASHBOARD
  //   if (currentUrl.includes('dashboard') && menu.id === 1) {
  //     menu.isSelected = true;
  //     return;
  //   }

  //   // LOOP subMenu properly
  //   menu.subMenu.forEach((subMenu: any) => {

  //     // CASE 1: has innerSubMenu
  //     if (subMenu.innerSubMenu) {
  //       subMenu.innerSubMenu.forEach((inner: any) => {
  //         if (currentUrl.includes(inner.link)) {
  //           menu.isSelected = true;
  //           menu.isOpen = true;

  //           subMenu.isSelected = true;
  //           subMenu.isOpen = true;

  //           inner.isSelected = true;
  //         }
  //       });
  //     }

  //     // CASE 2: normal subMenu
  //     else if (subMenu.link && currentUrl.includes(subMenu.link)) {
  //       menu.isSelected = true;
  //       menu.isOpen = true;
  //       subMenu.isSelected = true;
  //     }

  //   });
  // });



  //   this.updateMenuState(this.menuItems);
  }

  // updateSelectedMenu(currentUrl: string): void {
  //   // Reset selection states but preserve open states
  //   this.menuItems.forEach((menu: any) => {
  //     menu.isSelected = false;
  //     menu.subMenu.forEach((subMenu: any) => subMenu.isSelected = false);
  //   });

  //   if (currentUrl.includes('dashboard') && this.menuItems.some(m => m.id == 1)) {
  //     const dashboardMenu = this.menuItems.find(m => m.id == 1);
  //     if (dashboardMenu) {
  //       dashboardMenu.isSelected = true;
  //     }
  //   } else {
  //     // Find the menu that contains the current URL
  //     const activeMenu = this.menuItems.find(menu =>
  //       menu.subMenu.some((subMenu: any) => currentUrl.includes(subMenu.link))
  //     );

  //     console.log(activeMenu, 'is your active menu');

  //     this.menuItems.forEach((item:any) => console.log(item.name, item.isOpen));

  //     if (activeMenu) {
  //       activeMenu.isSelected = true;
  //       activeMenu.isOpen = true;

  //       // Mark the correct submenu as selected
  //       activeMenu.subMenu.forEach((subMenu: any) => {
  //         if (currentUrl.includes(subMenu.link)) {
  //           subMenu.isSelected = true;
  //         }
  //       });
  //     }
  //   }
  //   this.updateMenuState(this.menuItems);
  // }

  encryptPremitiveData(routeData: string): string {
    console.log('routeData', routeData);
    const encrypted = CryptoJS.AES.encrypt(
      routeData,
      this.routerSecrectKey
    ).toString();
    return encodeURIComponent(
      encrypted
    );
  }

  decryptPremitiveData(encryptedData: string): string {
    try {
      var decodedData = decodeURIComponent(encryptedData);
      decodedData = decodedData.replace(/-/g, '+').replace(/_/g, '/');
      var decrypteObj = CryptoJS.AES.decrypt(
        decodedData,
        this.routerSecrectKey
      );
      return decrypteObj.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      return '';
    }
  }

  // private isSidebarCollapsed = new BehaviorSubject<boolean>(false);
  // isSidebarCollapsed$ = this.isSidebarCollapsed.asObservable();
  // toggleSidebar() {
  //   const newState = !this.isSidebarCollapsed.value;
  //   this.isSidebarCollapsed.next(newState);
  // }
}
